function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 212.89,
  y1: 647.82,
  x2: 242.51,
  y2: -48.33,
  gradientTransform: "matrix(1, 0, 0, -1, 0.19, 516.56)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffd945"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#ffcd3e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#ffad2b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffa325"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 362.09,
  y1: 334.74,
  x2: -80.89,
  y2: 60.09,
  gradientTransform: "matrix(1, 0, 0, -1, 0.19, 516.56)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e87264",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#f67150",
  stopOpacity: 0.65
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff7044"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 333.53,
  y1: 322.76,
  x2: 508.11,
  y2: 322.76,
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 471.09,
  y1: 336.93,
  x2: 258.82,
  y2: 268.84,
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 185.4,
  y1: 172.7,
  x2: 94.39,
  y2: 263.7,
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 1.51,
  y1: 259.55,
  x2: 149.59,
  y2: 259.55,
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 118.19,
  y1: 271.57,
  x2: -61.86,
  y2: 213.81,
  xlinkHref: "#b"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "bolts");

var SvgBolts = function SvgBolts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M346.69,220.46a34.38,34.38,0,0,1-31.49-48.19L369.1,49.36A35.21,35.21,0,0,0,336.85,0H213.63a35.21,35.21,0,0,0-32.25,21.07L78.38,256a27.51,27.51,0,0,0,25.19,38.55H193.2a27.51,27.51,0,0,1,26.47,35L174.08,490.35c-5.06,17.89,18.2,29.69,29.64,15L377.28,283.16c19.9-25.49,1.74-62.7-30.59-62.7Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.72,505.4,377.28,283.16c19.9-25.49,1.74-62.7-30.59-62.7a34.37,34.37,0,0,1-31.48-48.19l53.9-122.91A35.22,35.22,0,0,0,336.85,0h-48.2L200.06,208.41a36.82,36.82,0,0,0,33.88,51.23c49,0,78.85,53.85,52.92,95.4L189,511.9a16.25,16.25,0,0,0,14.75-6.5Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.12,335.37l72.43-113.48a23.7,23.7,0,0,0-15.44-36L450.59,178a28.72,28.72,0,0,1-23.06-31.32L437.17,59c1.65-15-18.15-22-26.29-9.26l-72.11,113a23.69,23.69,0,0,0,15.82,36.07l39.5,7a28.71,28.71,0,0,1,23.51,31.4l-9.77,88.94c-1.65,15,18.14,22,26.29,9.27Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.11,185.89,450.59,178a28.72,28.72,0,0,1-23.06-31.32L437.17,59A13.93,13.93,0,0,0,428.9,44.4L396.11,146.09a33.73,33.73,0,0,0,19.44,41.62l18.84,7.64a33.72,33.72,0,0,1,19.16,42.44l-36.3,103.36a14,14,0,0,0,16.87-5.78l72.43-113.48a23.68,23.68,0,0,0-15.44-36Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.57,294.51h79.52L145,256.46a19.93,19.93,0,0,0-10.95-6.11l-34.37-6.69a24.23,24.23,0,0,1-12.87-7L78.38,256a27.51,27.51,0,0,0,25.19,38.55Z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75,377.14l61.44-96.25a20.1,20.1,0,0,0-13.1-30.54l-34.37-6.69A24.34,24.34,0,0,1,80.17,217.1l8.17-74.4C89.74,129.94,73,124,66,134.85L4.88,230.66a20.1,20.1,0,0,0,13.42,30.6l33.5,5.95a24.36,24.36,0,0,1,19.94,26.64l-8.29,75.44c-1.4,12.76,15.39,18.68,22.3,7.85Z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.09,250.35l-34.37-6.69A24.34,24.34,0,0,1,80.17,217.1l8.17-74.4a11.81,11.81,0,0,0-7-12.36L53.51,216.6A28.61,28.61,0,0,0,70,251.9l16,6.48a28.62,28.62,0,0,1,16.26,36L71.45,382.05a11.86,11.86,0,0,0,14.3-4.9l61.44-96.26a20.1,20.1,0,0,0-13.1-30.54Z",
    style: {
      fill: "url(#g)"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBolts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bolts.580872b7.svg";
export { ForwardRef as ReactComponent };